import React from "react";

export const TabButton = ({
  active,
  onClick,
  children,
  className = "text-xs",
}: {
  active: boolean;
  onClick: () => void;
  children: React.ReactNode;
  className?: string;
}) => (
  <button
    onClick={onClick}
    className={
      `px-2 py-1 font-semibold border-b-2 transition-colors ${className} ` +
      (active
        ? "border-bright-yellow text-black"
        : "border-transparent text-gray-400 hover:text-black")
    }
  >
    {children}
  </button>
);
